/**
 * Route constants for the application
 */

// Public routes
export const ROUTES = {
  HOME: '/',
  PRODUCTS: '/products',
  ABOUT: '/about',
  CONTACT: '/contact-us',
  
  // Auth routes
  LOGIN: '/login',
  SIGNUP: '/signup',
  
  // Admin routes
  ADMIN_DASHBOARD: '/admin',
  ADMIN_PRODUCTS: '/admin/products',
  ADMIN_ORDERS: '/admin/orders',
  ADMIN_USERS: '/admin/users',
  ADMIN_CATEGORIES: '/admin/categories',
} as const;

// Navigation items for header
export const NAV_ITEMS = [
  { label: 'Home', path: ROUTES.HOME },
  { label: 'Products', path: ROUTES.PRODUCTS },
  { label: 'About', path: ROUTES.ABOUT },
  { label: 'Contact', path: ROUTES.CONTACT },
] as const;

